import { baseConfig } from '@/config/_config-base.js'

export default {
  ...baseConfig,
  showGoToWebsiteLink: true,
  useUtmParamsForWebsiteLinks: true,
  stripeApiKeyPublic: 'pk_live_51Ipq5yAXnj3HeKyrsZB3wGIxbYdhr2QgCjqFm9KwFIJf8EXvmeNtG008LrT3vVHGKGQD6Xhlk0rHyittLgAlrXq200ara7ZyfV',
  api: {
    ...baseConfig.api,
    host: `https://api.app.planfred.com/${baseConfig.api.apiversion}`,
    companionUrl: `https://api.app.planfred.com/${baseConfig.api.apiversion}`, // we use CORS for uppy companion calls
    websocketServerUrl: 'https://api.app.planfred.com',
  },
  awsS3BucketHost: 'https://planfred.s3-accelerate.amazonaws.com',
  tasksBetaUsers: [], // If an array entry matches with the logged in users email (regex), a user can see the tasks tab
  customerFeatures: {
    ...baseConfig.customerFeatures,
    enableAgbPrivacyConfirmation: true,
    disableUserRegistrationForm: false,
    hideFeatureAlerts: false,
    account: {
      ...baseConfig.customerFeatures.account,
      disablePayment: false,
      disableDelete: false,
      disableUsedStorage: false,
    },
  },
}
